import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { RiCloseFill } from "react-icons/ri";
import { PopupContext } from '../../context/popupContext';
import { dateTimeIndo } from '../../utilities/helper';

const ModalPointDetail = ({ setShowModalDetailPoint, modalData, employeeData }) => {
    const { popupDispatch } = useContext(PopupContext)
    const clickRef = useRef(null)
    
    const [editorState, setEditorState] = useState(
        modalData.description === null
        ? EditorState.createEmpty()
        : EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(modalData.description)))
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (clickRef.current && !clickRef.current.contains(event.target)) {
                setShowModalDetailPoint(null)
                popupDispatch({ type: "POPUP_END" });
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clickRef])

    const handleModal = () => {
        setShowModalDetailPoint(null)
        popupDispatch({ type: "POPUP_END" });
    }

    return (
        // <div className="absolute top-0 left-0 z-10 p-3 w-screen min-h-screen overscroll-y-none overflow-y-hidden bg-black bg-opacity-70 flex items-center justify-center">
        <div className="fixed inset-0 z-10 p-3 w-screen h-screen overflow-y-auto bg-black bg-opacity-70 flex items-start justify-center">
            <div ref={clickRef}
                className="p-3 w-11/12 lg:w-1/3 md:w-1/2 my-5 bg-white rounded-md flex flex-col"
                // className="p-3 w-11/12 lg:w-1/3 md:w-1/2 h-full bg-white rounded-md flex flex-col"
            >
                <div className="px-2 flex justify-between items-center">
                    <h3 className='font-bold font-ssp text-xl md:text-2xl'>Detail Log Point</h3>
                    <RiCloseFill onClick={handleModal} className='w-8 h-8 cursor-pointer'/>
                </div>
                <div className='mt-5 px-5 w-full flex flex-col'>
                    {/* employee */}
                    <div className="relative z-0 mb-3 mt-3 w-full group">
                        <input 
                            value={employeeData.fullname+" - "+employeeData.Biodata.Office.name} 
                            type="text" 
                            name="employee" 
                            id="employee" 
                            readOnly
                            className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                        appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                            placeholder=" " 
                            required 
                        />
                        <label 
                            htmlFor="employee" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                        peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Employee</label>
                    </div>
                    <div className='flex flex-wrap justify-between'>
                        {/* point */}
                        <div className="relative z-0 mb-3 mt-3 w-full md:w-[45%] group">
                            <input 
                                value={modalData.point} 
                                type="number" 
                                name="point" 
                                id="point" 
                                className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                            appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                                placeholder=" " 
                                readOnly
                                required 
                            />
                            <label 
                                htmlFor="point" 
                                className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                            duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                            peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                            peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                            >Point</label>
                        </div>
                        {/* type */}
                        <div className="mb-3 mt-4 w-full md:w-[45%] relative z-0 group">
                            <input 
                                value={modalData.type === "revenue" ? "PENAMBAHAN" : "PENGURANGAN"} 
                                type="text" 
                                name="type" 
                                id="type" 
                                className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                            appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                                placeholder=" " 
                                readOnly
                                required 
                            />
                            <label 
                                htmlFor="type" 
                                className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                            duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                            peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                            peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                            >Type</label>
                        </div>
                    </div>
                    {/* last balance */}
                    <div className="relative z-0 mb-3 mt-3 w-full group">
                        <input 
                            value={modalData.last_balance} 
                            type="text" 
                            name="last_balance" 
                            id="last_balance" 
                            readOnly
                            className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                        appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                            placeholder=" " 
                            required 
                        />
                        <label 
                            htmlFor="last_balance" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                        peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Last Balance</label>
                    </div>
                    {/* description */}
                    <div className="mt-3 mb-6 w-full relative z-0 group">
                        <label 
                            htmlFor="description" 
                            className="text-sm text-gray-500 duration-300 transform -translate-y-6 
                                        scale-75 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:font-medium 
                                        peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Description</label>
                        <Editor
                            readOnly
                            editorState={editorState}
                            onEditorStateChange={setEditorState}
                            wrapperClassName="mt-2 border h-[500px] md:h-[300px] relative flex flex-col overflow-hidden border border-gray-300"
                            toolbarClassName="sticky"
                            editorClassName="px-2 overflow-y-scroll"
                        />
                    </div>
                    {/* admin */}
                    <div className="relative z-0 mb-3 mt-3 w-full group">
                        <input 
                            value={modalData.Approved_Point_Log.fullname} 
                            type="text" 
                            name="employee" 
                            id="employee" 
                            readOnly
                            className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                        appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                            placeholder=" " 
                            required 
                        />
                        <label 
                            htmlFor="employee" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                        peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Admin</label>
                    </div>
                    {/* time */}
                    <div className="relative z-0 mb-3 mt-3 w-full group">
                        <input 
                            value={dateTimeIndo(modalData.createdAt)} 
                            type="text" 
                            name="employee" 
                            id="employee" 
                            readOnly
                            className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                        appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                            placeholder=" " 
                            required 
                        />
                        <label 
                            htmlFor="employee" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                        peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Time</label>
                    </div>
                    {/* Button */}
                    <div className="mb-6 mt-5 w-full relative z-0 flex gap-3 justify-end">
                        <button onClick={handleModal} 
                            className="px-5 py-2.5 mt-5 w-full sm:w-auto bg-red-400 hover:bg-red-500 rounded-lg text-sm text-white
                                        text-center font-medium cursor-pointer"
                        >Close</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

ModalPointDetail.propTypes = {
    modalData: PropTypes.object, 
    employeeData: PropTypes.object,
    setShowModalDetailPoint: PropTypes.func,
}

export default ModalPointDetail